import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Form, Select, Radio, Spin, notification } from "antd";
import { IdcardTwoTone } from "@ant-design/icons";
import InputMask from "react-input-mask";
import { IoInformationCircle } from "react-icons/io5";
import {
  ModalForm,
  ModalTitle,
  StyledInput,
  StyledSelect,
  StyledFormItem,
  ButtonFormConfirm,
  StyledSpan,
  EventParticipationContainer,
  ModalRegisterSuccess,
  ModalDelete,
  CollaboratorToDeleteLabel,
  CollaboratorToDeleteContainer,
  HeaderModal,
  CautionContainer,
  StyledDDISelect,
  TelephoneSpan,
  CustomExtraLabel,
  FlagOption,
  PhoneErrorText,
} from "./styles";

import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { validation } from "../../newUXPages/Credentials/Register/NewEmployee/validations";
import api from "../../service";
import { getCredentialsQuotaService } from "../../service/credentials.service";
import { SubTitle } from "../../pages/StaffAccess/Services/style";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegTrashAlt } from "react-icons/fa";
import {
  getCountries,
  getCountryCallingCode,
  parsePhoneNumber,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import pt from "react-phone-number-input/locale/pt.json";
import flags from "react-phone-number-input/flags";
import {
  getBrazilianStates,
  getBrazilianCitiesByStateId,
} from "../../service/localities.service";
import { DEFAULT_DDI_COUNTRY_KEY } from "../../utils/declarationConstants";
import {
  buildCredentialName,
  allowCredentialNameToReceiveValue,
} from "../../utils/credentialName";

const ModalNewCollaborator = ({
  visible,
  setModalVisible,
  editingId,
  setEditingId,
  setIsEditing,
  isEditing,
  modalVisibleDelete,
  selectedRows,
  setIsModalDeleteVisible,
  handleDelete,
  fetchData,
  notDisplaySuccessModal,
  isServiceProvider,
}) => {
  const [form] = Form.useForm();
  const [isParticipation, setIsParticipation] = useState(false);
  const { Option } = Select;
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const [isModalSuccessVisible, setIsModalSuccessVisible] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const eventId = localStorage.getItem("serviceEventId");
  const opportunityId = localStorage.getItem("serviceOpportunityId");
  const serviceSystemUserId = localStorage.getItem("serviceSystemUserId");
  const [credentialTypes, setCredentialTypes] = useState([]);
  const isPortuguese = useMemo(() => intl.locale === "pt", [intl.locale]);
  const [countryList, setCountryList] = useState([]);
  const [nationality, setNationality] = useState(false);
  const [editingIsServiceProvider, setEditingIsServiceProvider] =
    useState(false);
  const isCollaboratorServiceProvider = isEditing
    ? editingIsServiceProvider
    : !!isServiceProvider;
  const [countries, setCountries] = useState([]);
  const [brazilianStates, setBrazilianStates] = useState([]);
  const [brazilianCities, setBrazilianCities] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState();
  const [loadedState, setLoadedState] = useState();
  const [loadedCity, setLoadedCity] = useState();
  const [hasLoadedCity, setHasLoadedCity] = useState(false);
  const [canApplyCredentialName, setCanApplyCredentialName] = useState(true);

  const fetchCredentialCategories = useCallback(async () => {
    if (!eventId || !opportunityId || !serviceSystemUserId) return;

    setLoadingForm(true);
    try {
      const result = await getCredentialsQuotaService({
        event_id: eventId,
        opportunity_id: opportunityId,
        user_id: serviceSystemUserId,
      });

      const credentialCategories =
        result?.data?.credentialCategoryOutputList?.map((item) => ({
          label: isPortuguese ? item.title : item.englishTitle,
          value: item.credentialType,
        })) || [];

      setCredentialTypes(credentialCategories);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: `api.error.${error.response?.data?.description || "unknown"}`,
        }),
      });
    } finally {
      setLoadingForm(false);
    }
  }, [eventId, opportunityId, serviceSystemUserId, isPortuguese, intl]);

  // ✅ Memoizar a função com useCallback
  const fetchCollaborator = useCallback(async () => {
    if (!editingId) return;

    setLoadingForm(true);
    try {
      const result = await api.get(
        `/associate-collaborators/admin/${editingId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fullPhone = result.data.associateCollaboratorOutput.telephone ?? "";
      const parsedPhone = fullPhone ? parsePhoneNumber(fullPhone) : undefined;
      const ddiMatch = fullPhone.match(/^\+\d+/);
      const ddi = parsedPhone
        ? `+${parsedPhone.countryCallingCode}`
        : ddiMatch
          ? ddiMatch[0]
          : "";
      const phoneWithoutDdi = parsedPhone
        ? parsedPhone.nationalNumber
        : fullPhone.replace(ddi, "").trim();
      const document = result.data.associateCollaboratorOutput.document ?? "";
      // Vários países compartilham o mesmo DDI (ex: +1 = EUA, Canadá, Bahamas...),
      // então priorizamos o país detectado pelo parser a partir do número completo.
      const matchedCountry = parsedPhone?.country
        ? countryList.find(
            (country) => country.countryCode === parsedPhone.country,
          )
        : countryList.find((country) => country.value === ddi);

      form.setFieldsValue({
        name: result.data.associateCollaboratorOutput.name ?? "",
        last_name: result.data.associateCollaboratorOutput.lastName ?? "",
        credential_name:
          result.data.associateCollaboratorOutput.credentialName ?? "",
        document,
        assignment: result.data.associateCollaboratorOutput.jobTitle ?? "",
        email: result.data.associateCollaboratorOutput.email ?? "",
        telephone: phoneWithoutDdi,
        // colaboradores legados podem nao ter DDI reconhecivel no telefone salvo;
        // nesse caso, assume-se o Brasil como padrao para agilizar a edicao.
        ddi: matchedCountry?.key ?? DEFAULT_DDI_COUNTRY_KEY,
        country: result.data.associateCollaboratorOutput.country ?? "",
        internationalCity: result.data.associateCollaboratorOutput.city ?? "",
        state: result.data.associateCollaboratorOutput.state ?? "",
        brazilianCity: result.data.associateCollaboratorOutput.city ?? "",
      });

      setNationality(!(String(document).replace(/\D/g, "").length === 11));
      setLoadedState(result.data.associateCollaboratorOutput.state || "[]");
      setLoadedCity(result.data.associateCollaboratorOutput.city || "[]");
      setEditingIsServiceProvider(
        result.data.associateCollaboratorOutput.userRoleType ===
          "SERVICE_PROVIDER",
      );
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: `api.error.${error.response?.data?.description || "unknown"}`,
        }),
      });
    } finally {
      setLoadingForm(false);
    }
  }, [editingId, token, intl, form, countryList]);

  useEffect(() => {
    if (visible && !isEditing) {
      fetchCredentialCategories();
      form.setFieldValue("ddi", DEFAULT_DDI_COUNTRY_KEY);
    }
  }, [visible, isEditing, fetchCredentialCategories, form]);

  useEffect(() => {
    if (visible && editingId && isEditing) {
      fetchCollaborator();
    }
  }, [visible, editingId, isEditing, fetchCollaborator]);

  useEffect(() => {
    const fetchBrazilianStates = async () => {
      try {
        setLoadingForm(true);
        const states = await getBrazilianStates();
        setBrazilianStates(states);
      } catch (error) {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({ id: "error.loading_states" }),
        });
        setBrazilianStates([]);
      } finally {
        setLoadingForm(false);
      }
    };

    const reactCountries = getCountries().map((country) => {
      const code = "+" + getCountryCallingCode(country);
      const countryName = isPortuguese ? pt[country] : en[country];
      return {
        label: `${code} - ${countryName}`,
        value: code,
        name: countryName,
        key: `${code}-${country}`,
        countryCode: country,
      };
    });
    setCountryList(reactCountries.sort((a, b) => a.name.localeCompare(b.name)));

    const allCountries = getCountries();
    const countryList = isPortuguese ? pt : en;
    const countriesOptions = allCountries.map((countryCode) => ({
      label: countryList[countryCode],
      value: countryList[countryCode],
    }));
    const sortedCountries = countriesOptions.sort((a, b) =>
      a.label.localeCompare(b.label),
    );
    setCountries(sortedCountries);

    fetchBrazilianStates();
  }, [isPortuguese]);

  useEffect(() => {
    if (nationality || !loadedState || brazilianStates.length === 0) return;

    const foundState = brazilianStates.find(
      (state) => state.value === loadedState,
    );
    if (foundState) {
      fetchBrazilianCities(foundState.stateId);
    } else {
      form.setFieldValue("state");
      form.setFieldValue("brazilianCity");
      setHasLoadedCity(true);
      notification.warning({
        message: intl.formatMessage({ id: "warning" }),
        description: intl.formatMessage(
          { id: "state_not_found" },
          { state: loadedState },
        ),
      });
    }
  }, [loadedState, brazilianStates]);

  useEffect(() => {
    if (
      nationality ||
      !loadedCity ||
      brazilianCities.length === 0 ||
      hasLoadedCity
    )
      return;

    const foundCity = brazilianCities.find((city) => city.value === loadedCity);
    if (!foundCity) {
      form.setFieldValue("brazilianCity");
      notification.warning({
        message: intl.formatMessage({ id: "warning" }),
        description: intl.formatMessage(
          { id: "city_not_found" },
          { city: loadedCity },
        ),
      });
    }

    setHasLoadedCity(true);
  }, [loadedCity, brazilianCities]);

  useEffect(() => {
    form.setFieldValue("brazilianCity");
    if (!selectedStateId) return;

    fetchBrazilianCities(selectedStateId);
  }, [selectedStateId]);

  const handleSubmit = async (values) => {
    setLoadingButton(true);
    const doc = values.document.replace(/\D/g, "");
    const international = !(
      String(values.document).replace(/\D/g, "").length === 11
    );
    try {
      const employee = {
        name: values.name,
        lastName: values.last_name,
        credentialName: values.credential_name,
        document:
          doc.length === 11
            ? doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
            : values.document,
        jobTitle: values.assignment,
        email: values.email,
        telephone: `${values.ddi.split("-")[0]} ${values.telephone}`,
        credentialType: values.credential_type,
        createCredential: isParticipation ? true : false,
        eventId: Number(eventId),
        fastTrack: isCollaboratorServiceProvider,
        international: !(
          String(values.document).replace(/\D/g, "").length === 11
        ),
        userId: Number(serviceSystemUserId),
        opportunityId: Number(opportunityId),
        country: international ? values.country : null,
        state: !international ? values.state : null,
        city: international ? values.internationalCity : values.brazilianCity,
      };

      let response;

      if (editingId && isEditing) {
        response = await api.put(
          `/associate-collaborators/admin/${editingId}`,
          employee,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          },
        );
      } else {
        response = await api.post("/associate-collaborators/admin", employee, {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      if (response?.data?.code === 10004) {
        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({ id: "success.10004" }),
        });
        setIsEditing(false);
      }
      if (response?.data?.code === 10006) {
        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({ id: "success.10006" }),
        });
        setIsModalSuccessVisible(true);
      }
      if (response?.data?.code === 10001) {
        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({ id: "success.10001" }),
        });
        if (!notDisplaySuccessModal) {
          setIsModalSuccessVisible(true);
        }
      }

      setModalVisible(false);
      form.resetFields();
      setBrazilianCities([]);
      setSelectedStateId();
      setLoadedState();
      setLoadedCity();
      setHasLoadedCity(false);
      fetchData();
      setIsParticipation(false);
      editingId && setEditingId(null);
      setNationality(false);

      return response.data;
    } catch (error) {
      const code = error?.response?.data?.code;

      if (code === -10011 || code === -10012) {
        notification.warning({
          message: intl.formatMessage({ id: "warning" }),
          description: intl.formatMessage({ id: `api.error.${code}` }),
        });
      } else {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: `api.error.${code || "unknown"}`,
          }),
        });
      }
    } finally {
      setLoadingButton(false);
    }
  };

  const fetchBrazilianCities = async (stateId) => {
    try {
      setLoadingForm(true);
      const cities = await getBrazilianCitiesByStateId(stateId);
      setBrazilianCities(cities);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({ id: "error.loading_cities" }),
      });
      setBrazilianCities([]);
    } finally {
      setLoadingForm(false);
    }
  };

  const handleStateChange = (stateValue, option) => {
    form.setFieldValue("brazilianCity");

    if (!option?.stateId) {
      setBrazilianCities([]);
      return;
    }

    fetchBrazilianCities(option.stateId);
  };

  const registerNewEmployeeModalControl = () => {
    setModalVisible(true);
    setIsModalSuccessVisible(false);
  };

  const onCancel = () => {
    form.resetFields();
    setBrazilianCities([]);
    setSelectedStateId();
    setLoadedState();
    setLoadedCity();
    setHasLoadedCity(false);
    setModalVisible(false);
    editingId && setEditingId(null);
    isEditing && setIsEditing(false);
    setIsParticipation(false);
    setNationality(false);
  };

  const handleDocumentChange = (e) => {
    const value = e.target.value;
    const international = !(String(value).replace(/\D/g, "").length === 11);

    if (nationality !== international) {
      form.setFieldsValue({
        country: undefined,
        state: undefined,
        brazilianCity: undefined,
        internationalCity: undefined,
      });
      setBrazilianCities([]);
      setSelectedStateId();
      setHasLoadedCity(true);
    }
    setNationality(international);

    if (international === true) {
      const upperValue = value.toUpperCase();
      form.setFieldValue("document", upperValue);
    } else {
      form.setFieldValue("document", value);
    }

    setTimeout(() => {
      form.validateFields(["document"]);
    }, 300);
  };

  const handleDocumentBlur = () => {
    const value = form.getFieldValue("document");

    if (!value) return;

    form.validateFields(["document"]);
  };

  const labelWithExtra = (labelKey, extraKey, extraValues = {}) => (
    <span>
      {intl.formatMessage({ id: labelKey })}
      <CustomExtraLabel>
        {intl.formatMessage({ id: extraKey }, extraValues)}
      </CustomExtraLabel>
    </span>
  );

  const filterFunction = (input, option) => {
    const searchTerm = input.toLowerCase().replace(/[+\s-]/g, "");

    const optionValue =
      option?.children?.toLowerCase().replace(/[+\s-]/g, "") || "";

    return optionValue.includes(searchTerm);
  };

  const handleBuildCredentialName = () => {
    if (!canApplyCredentialName || isEditing) return;

    const { name, last_name } = form.getFieldsValue(["name", "last_name"]);
    const credentialName = buildCredentialName(name, last_name);

    if (!credentialName.trim()) return;

    form.setFieldValue("credential_name", credentialName);
    form.validateFields(["credential_name"]);
  };

  const handleCredentialNameChange = () => {
    if (isEditing) return;

    const {
      name,
      last_name,
      credential_name
    } = form.getFieldsValue(["name", "last_name", "credential_name"]);

    setCanApplyCredentialName(
      allowCredentialNameToReceiveValue(name, last_name, credential_name));
  };

  return (
    <>
      <ModalRegisterSuccess
        visible={isModalSuccessVisible}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ButtonFormConfirm
              type="primary"
              onClick={registerNewEmployeeModalControl}
              style={{
                backgroundColor: "rgba(6, 142, 195, 1)",
                width: "100%",
              }}
            >
              {intl.formatMessage({ id: "register" })}
            </ButtonFormConfirm>
            <ButtonFormConfirm
              onClick={() => setIsModalSuccessVisible(false)}
              style={{
                border: "none",
                marginTop: "10px",
                width: "100%",
              }}
            >
              {intl.formatMessage({ id: "close" })}
            </ButtonFormConfirm>
          </div>,
        ]}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          <FaCheckCircle style={{ fontSize: "72px", marginBottom: "10px" }} />
          <SubTitle style={{ marginBottom: 0 }}>
            {intl.formatMessage({ id: "collaborator_registered_successfully" })}
          </SubTitle>
          <StyledSpan style={{ marginBottom: 0 }}>
            {intl.formatMessage({ id: "register_another_collaborator" })}
          </StyledSpan>
        </div>
      </ModalRegisterSuccess>

      <ModalDelete
        centered
        closable={false}
        footer={[
          <>
            <ButtonFormConfirm
              onClick={() => setIsModalDeleteVisible(false)}
              style={{ border: "none" }}
            >
              {intl.formatMessage({ id: "cancel" })}
            </ButtonFormConfirm>
            <ButtonFormConfirm
              loading={loadingButton}
              type="primary"
              onClick={() => handleDelete()}
              style={{
                backgroundColor: "rgba(185, 28, 28, 1)",
              }}
            >
              {intl.formatMessage({ id: "delete" })}
            </ButtonFormConfirm>
          </>,
        ]}
        visible={modalVisibleDelete}
      >
        <HeaderModal>
          <FaRegTrashAlt
            style={{ fontSize: "16px", color: "rgba(6, 142, 195, 1)" }}
          />
          <ModalTitle>
            {intl.formatMessage({ id: "delete_collaborator" })}
          </ModalTitle>
        </HeaderModal>
        <StyledSpan>
          {intl.formatMessage({ id: "confirm_collaborator_deletion" })}
        </StyledSpan>
        <br />
        <StyledSpan style={{ fontWeight: "bold" }}>
          {intl.formatMessage({ id: "this_action_cannot_be_undone" })}
        </StyledSpan>
        <CollaboratorToDeleteContainer>
          {selectedRows?.map((row) => (
            <CollaboratorToDeleteLabel key={row.id}>
              • {row.name}
            </CollaboratorToDeleteLabel>
          ))}
        </CollaboratorToDeleteContainer>
      </ModalDelete>

      <ModalForm
        centered
        width={658}
        open={visible}
        closable={false}
        footer={null}
        onCancel={onCancel}
      >
        <HeaderModal>
          <IdcardTwoTone style={{ fontSize: "24px" }} />
          <ModalTitle>
            {isEditing
              ? intl.formatMessage({ id: "edit_collaborator" })
              : intl.formatMessage({ id: "new_collaborator" })}
          </ModalTitle>
        </HeaderModal>
        <Spin
          spinning={loadingForm}
          tip={intl.formatMessage({ id: "loading" })}
        >
          <Form onFinish={handleSubmit} form={form} layout="vertical">
            <div style={{ display: "flex" }}>
              <StyledFormItem
                label={intl.formatMessage({ id: "name" })}
                name="name"
                rules={validation("name", intl)}
                style={{ flex: 1, marginRight: "5px" }}
              >
                <StyledInput
                  type="text"
                  placeholder={intl.formatMessage({ id: "name" })}
                  maxLength={23}
                  onBlur={handleBuildCredentialName}
                />
              </StyledFormItem>

              <StyledFormItem
                label={intl.formatMessage({ id: "last_name" })}
                name="last_name"
                rules={validation("last_name", intl)}
                style={{ flex: 1, marginLeft: "5px" }}
              >
                <StyledInput
                  type="text"
                  placeholder={intl.formatMessage({ id: "last_name" })}
                  maxLength={23}
                  onBlur={handleBuildCredentialName}
                />
              </StyledFormItem>
            </div>

            <StyledFormItem
              label={intl.formatMessage({ id: "document" })}
              name="document"
              rules={validation("document", intl, nationality)}
            >
              <StyledInput
                name="document"
                placeholder={intl.formatMessage({
                  id: "enter_CPF_or_passport",
                })}
                onChange={handleDocumentChange}
                onBlur={handleDocumentBlur}
              />
            </StyledFormItem>

            <CautionContainer>
              <IoInformationCircle style={{ fontSize: "25px" }} />
              <span>{intl.formatMessage({ id: "CPF_or_passport" })}</span>
            </CautionContainer>

            <StyledFormItem
              label={labelWithExtra("assignment", "up_to_custom_characters", {
                quantity: 50,
              })}
              name="assignment"
              rules={validation("assignment", intl)}
            >
              <StyledInput
                placeholder={intl.formatMessage({ id: "assignment" })}
                maxLength={50}
              />
            </StyledFormItem>

            <StyledFormItem
              label={labelWithExtra(
                "credential_name",
                "up_to_custom_characters",
                { quantity: 23 },
              )}
              name="credential_name"
              rules={validation("credential_name", intl)}
            >
              <StyledInput
                placeholder={intl.formatMessage({ id: "credential_name" })}
                maxLength={23}
                onBlur={handleCredentialNameChange}
              />
            </StyledFormItem>

            <StyledFormItem
              label={intl.formatMessage({ id: "email" })}
              name="email"
              rules={validation(
                "email",
                intl,
                false,
                false,
                isCollaboratorServiceProvider,
              )}
            >
              <StyledInput
                placeholder={intl.formatMessage({ id: "email" })}
                type="email"
              />
            </StyledFormItem>

            {nationality ? (
              <>
                <StyledFormItem
                  label={intl.formatMessage({ id: "country" })}
                  name="country"
                  rules={validation("country", intl, nationality)}
                >
                  <StyledSelect
                    dropdownMatchSelectWidth
                    showSearch
                    filterOption={filterFunction}
                    placeholder={intl.formatMessage({
                      id: "select_country_where_live"
                    })}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {countries.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </StyledSelect>
                </StyledFormItem>

                <StyledFormItem
                  label={intl.formatMessage({ id: "city" })}
                  name="internationalCity"
                  rules={validation("internationalCity", intl, nationality)}
                >
                  <StyledInput
                    placeholder={intl.formatMessage({
                      id: "type_city_where_live"
                    })}
                    maxLength={50}
                  />
                </StyledFormItem>
              </>
            ) : (
              <>
                <StyledFormItem
                  label={intl.formatMessage({ id: "state" })}
                  name="state"
                  rules={validation("state", intl, nationality)}
                >
                  <StyledSelect
                    dropdownMatchSelectWidth
                    showSearch
                    filterOption={filterFunction}
                    placeholder={intl.formatMessage({
                      id: "select_state_where_live"
                    })}
                    onChange={(stateValue, option) =>
                      setSelectedStateId(option?.stateId)
                    }
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {brazilianStates.map((option) => (
                      <Option
                        key={option.value}
                        value={option.value}
                        stateId={option.stateId}
                      >
                        {option.label}
                      </Option>
                    ))}
                  </StyledSelect>
                </StyledFormItem>

                <StyledFormItem
                  label={intl.formatMessage({ id: "city" })}
                  name="brazilianCity"
                  rules={validation("brazilianCity", intl, nationality)}
                >
                  <StyledSelect
                    dropdownMatchSelectWidth
                    showSearch
                    filterOption={filterFunction}
                    placeholder={intl.formatMessage({
                      id: "select_city_where_live"
                    })}
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {brazilianCities.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </StyledSelect>
                </StyledFormItem>
              </>
            )}

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <TelephoneSpan>
                  {intl.formatMessage({ id: "telephone" })}
                  <span className="required">*</span>
                </TelephoneSpan>
                <StyledFormItem
                  name="ddi"
                  noStyle
                  rules={validation("ddi", intl)}
                >
                  <StyledDDISelect
                    dropdownMatchSelectWidth={340}
                    showSearch
                    optionLabelProp="label"
                    filterOption={(input, option) => {
                      const searchTerm = input
                        .toLowerCase()
                        .replace(/[+\s-]/g, "");

                      const optionValue =
                        option?.filterLabel
                          ?.toLowerCase()
                          .replace(/[+\s-]/g, "") || "";

                      return optionValue.includes(searchTerm);
                    }}
                    placeholder="DDI"
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {countryList.map((country) => {
                      const Flag = flags[country.countryCode];
                      return (
                        <Option
                          key={country.key}
                          value={country.key}
                          filterLabel={country.label}
                          label={
                            <FlagOption>
                              {Flag && <Flag title={country.name} />}
                              {country.value}
                            </FlagOption>
                          }
                        >
                          <FlagOption>
                            {Flag && <Flag title={country.name} />}
                            {country.label}
                          </FlagOption>
                        </Option>
                      );
                    })}
                  </StyledDDISelect>
                </StyledFormItem>
              </div>

              <StyledFormItem
                name="telephone"
                noStyle
                rules={validation("telephone", intl)}
              >
                <StyledInput
                  style={{ flex: 1, marginTop: "30px" }}
                  placeholder={`(DDD) + ${intl.formatMessage({
                    id: "telephone",
                  })}`}
                  as={InputMask}
                  mask="(99) 99999-9999"
                  maskPlaceholder={null}
                  alwaysShowMask={false}
                />
              </StyledFormItem>
            </div>

            <Form.Item shouldUpdate noStyle>
              {() => {
                const message =
                  form.getFieldError("ddi")[0] ||
                  form.getFieldError("telephone")[0];
                return message ? (
                  <PhoneErrorText>{message}</PhoneErrorText>
                ) : null;
              }}
            </Form.Item>

            {!isEditing && (
              <>
                <EventParticipationContainer>
                  <StyledSpan>
                    {intl.formatMessage({ id: "employee_participation_event" })}
                  </StyledSpan>

                  <Radio.Group
                    value={isParticipation}
                    onChange={(e) => setIsParticipation(e.target.value)}
                  >
                    <Radio value={false}>
                      {intl.formatMessage({ id: "no" })}
                    </Radio>
                    <Radio value={true}>
                      {intl.formatMessage({ id: "yes" })}
                    </Radio>
                  </Radio.Group>
                </EventParticipationContainer>

                {isParticipation && (
                  <StyledFormItem
                    name="credential_type"
                    label={intl.formatMessage({ id: "credential_type" })}
                    rules={validation("credentialType", intl)}
                  >
                    <StyledSelect
                      style={{ width: "100%" }}
                      dropdownMatchSelectWidth
                      placeholder={intl.formatMessage({ id: "select" })}
                    >
                      {credentialTypes.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </StyledSelect>
                  </StyledFormItem>
                )}
              </>
            )}
          </Form>
        </Spin>

        <div className="ant-modal-footer">
          <ButtonFormConfirm onClick={onCancel} style={{ border: "none" }}>
            {intl.formatMessage({ id: "cancel" })}
          </ButtonFormConfirm>
          <ButtonFormConfirm
            loading={loadingButton}
            type="primary"
            onClick={() => form.submit()}
            style={{
              backgroundColor: "rgba(6, 142, 195, 1)",
            }}
          >
            {isEditing
              ? intl.formatMessage({ id: "save" })
              : intl.formatMessage({ id: "register" })}
          </ButtonFormConfirm>
        </div>
      </ModalForm>
    </>
  );
};

export default ModalNewCollaborator;
